import { db } from "../config/firebase";
import { ref, get } from "firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions";

export const getAllCompanies = async () => {
  const snapshot = await get(ref(db, "companies"));
  if (!snapshot.exists()) return [];
  return Object.entries(snapshot.val()).map(([id, val]) => ({
    id,
    ...val,
    userCount: val.users ? Object.keys(val.users).length : 0
  }));
};

export const createCompanySecure = async (
  companyId, companyName, adminEmail, adminPassword, maxUsers, plan
) => {
  const fn = httpsCallable(getFunctions(), "createCompany");
  const result = await fn({ companyId, companyName, adminEmail, adminPassword, maxUsers, plan });
  return result.data;
};

export const suspendCompanySecure = async (companyId, suspend) => {
  const fn = httpsCallable(getFunctions(), "suspendCompany");
  const result = await fn({ companyId, suspend });
  return result.data;
};

export const deleteCompanySecure = async (companyId) => {
  const fn = httpsCallable(getFunctions(), "deleteCompany");
  const result = await fn({ companyId });
  return result.data;
};

export const editCompanyDetails = async ({
  companyId,
  newName,
  newMaxUsers,
  newAdminEmail,
  newAdminPassword,
}) => {
  const fn = httpsCallable(getFunctions(), "editCompany");
  const result = await fn({
    companyId,
    newName,
    newMaxUsers,
    newAdminEmail,
    newAdminPassword,
  });
  return result.data;
};